import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/components/Home'

Vue.use(Router)

let router = new Router({
    routes: [{
            path: '/',
            name: 'home',
            component: Home
        },
        {
            path: '*',
            redirect: {
                name: 'home'
            }
        }
    ],
    scrollBehavior() {
        return {
            x: 0,
            y: 0
        }
    }
});

export default router